import { jsx as d } from "react/jsx-runtime";
import e from "react";
import { cva as u } from "../../../../../node_modules/class-variance-authority/dist/index.js";
import { cn as n } from "../../utils/cn.js";
const o = {
  xs: 16,
  sm: 16,
  base: 20,
  lg: 24
}, b = e.forwardRef(
  (r, g) => {
    const { className: i, variant: a, size: t, children: s, ...c } = r;
    if (!e.isValidElement(s))
      return null;
    const l = n(f({ variant: a, size: t, className: i }));
    return /* @__PURE__ */ d("button", { ref: g, className: l, type: "button", ...c, children: e.cloneElement(s, {
      ...s.props,
      width: o[t || "sm"],
      height: o[t || "sm"]
    }) });
  }
);
b.displayName = "IconButton";
const f = u(
  n(
    "gst-border-base gst-border-solid",
    // Foundation reset
    "gst-inline-flex gst-items-center gst-justify-center gst-transition-colors gst-rounded-full gst-ring-offset-2 focus-visible:gst-outline-none focus-visible:gst-ring-2 focus-visible:gst-ring-ring disabled:gst-pointer-events-none disabled:gst-opacity-50 [&_svg]:gst-pointer-events-none"
  ),
  {
    variants: {
      variant: {
        outline: "gst-border gst-border-input gst-bg-background gst-shadow-sm hover:gst-bg-accent hover:gst-text-accent-foreground",
        filled: "gst-bg-secondary gst-text-secondary-foreground gst-shadow-sm hover:gst-bg-secondary/80",
        ghost: "hover:gst-bg-accent hover:gst-text-accent-foreground"
      },
      size: {
        xs: "gst-h-6 gst-w-6",
        sm: "gst-h-8 gst-w-8",
        base: "gst-h-10 gst-w-10",
        lg: "gst-h-12 gst-w-12"
      }
    },
    defaultVariants: {
      variant: "filled",
      size: "base"
    }
  }
);
export {
  o as ICON_SIZE_MAPPER,
  b as default
};
